import { render } from "./Scenario.vue?vue&type=template&id=6b9e9dd2&scoped=true&ts=true"
import script from "./Scenario.vue?vue&type=script&lang=ts"
export * from "./Scenario.vue?vue&type=script&lang=ts"

import "./Scenario.vue?vue&type=style&index=0&id=6b9e9dd2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9e9dd2"]])

export default __exports__